module.exports = __webpack_public_path__ + "static/Red Card-232f2533833384a051fedc43aea95c3d.png";